import { match } from 'variant';
import { z } from 'zod';
import type { TFunction } from '@wix/cli-i18n';
import { generateFlowKeyToSelectOption } from './generateFlows.js';

// Extension type name as it stated in docs.
// This is the main entry point of the user for extension generation.
export const docsExtensionTypeSchema = z.enum([
  'DASHBOARD_PAGE',
  'DASHBOARD_MODAL',
  'DASHBOARD_PLUGIN',
  'DASHBOARD_MENU_PLUGIN',
  'SITE_WIDGET',
  'EMBEDDED_SCRIPT',
  'SITE_PLUGIN',
  'WEB_METHOD',
  'HTTP_FUNCTION',
  'BACKEND_EVENT',
  'SERVICE_PLUGIN',
]);

export type DocsExtensionType = z.infer<typeof docsExtensionTypeSchema>;

export const getGenerateFlowByDocsExtensionType = (
  type: DocsExtensionType,
  t: TFunction
) => {
  return match(type, {
    DASHBOARD_PAGE: () => {
      return generateFlowKeyToSelectOption('dashboard-page', t);
    },
    DASHBOARD_MODAL: () => {
      return generateFlowKeyToSelectOption('dashboard-modal', t);
    },
    DASHBOARD_PLUGIN: () => {
      return generateFlowKeyToSelectOption('dashboard-plugin', t);
    },
    DASHBOARD_MENU_PLUGIN: () => {
      return generateFlowKeyToSelectOption('dashboard-menu-plugin', t);
    },
    SITE_WIDGET: () => {
      return generateFlowKeyToSelectOption('custom-element', t);
    },
    EMBEDDED_SCRIPT: () => {
      return generateFlowKeyToSelectOption('embedded-script', t);
    },
    SITE_PLUGIN: () => {
      return generateFlowKeyToSelectOption('site-plugin', t);
    },
    WEB_METHOD: () => {
      return generateFlowKeyToSelectOption('api', t);
    },
    HTTP_FUNCTION: () => {
      return generateFlowKeyToSelectOption('api', t);
    },
    BACKEND_EVENT: () => {
      return generateFlowKeyToSelectOption('event', t);
    },
    SERVICE_PLUGIN: () => {
      return generateFlowKeyToSelectOption('service-plugin', t);
    },
  });
};
